export function isPartialOutsideCandle(lastSequence) {
  if (!lastSequence.currentSequence) return false;

  if (lastSequence.currentSequenceName === 'OUTSIDE_CANDLE') {
    if (!lastSequence.brokeHigh && !lastSequence.brokeLow) {
      return {
        displayTriggerPrice: false,
        showPartialBox: false,
      };
    }
    if (lastSequence.brokeLow) {
      return {
        displayTriggerPrice: 'priceToBreakHigh',
        sequence: 'OUTSIDE_CANDLE',
        showPartialBox: 'bottom',
      };
    }
    if (lastSequence.brokeHigh) {
      return {
        displayTriggerPrice: 'priceToBreakLow',
        sequence: 'OUTSIDE_CANDLE',
        showPartialBox: 'top',
      };
    }
  }
  if (lastSequence.currentSequenceName === 'OUTSIDE_CANDLE_DOWN') {
    if (!lastSequence.brokeHigh) {
      return {
        displayTriggerPrice: false,
        showPartialBox: false,
      };
    }
    return {
      displayTriggerPrice: 'priceToBreakLow',
      sequence: 'OUTSIDE_CANDLE_DOWN',
      showPartialBox: 'top',
    };
  }
  if (lastSequence.currentSequenceName === 'OUTSIDE_CANDLE_UP') {
    if (!lastSequence.brokeLow) {
      return {
        displayTriggerPrice: false,
        showPartialBox: false,
      };
    }
    return {
      displayTriggerPrice: 'priceToBreakHigh',
      sequence: 'OUTSIDE_CANDLE_UP',
      showPartialBox: 'bottom',
    };
  }
  return false;
}
